import { Suspense } from 'react';
import { Skeleton } from '@sara/ui/components/skeleton';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getListRubricsQueryOptions } from '@sara/api-client';
import { RubricList } from '../../components/RubricList/RubricList';
import { toSuspense } from '../../../../lib/query';
import { useOrgSlug } from '../../../auth';

interface RubricListContainerProps {
  orgId: string;
}

function RubricListSkeleton() {
  return (
    <div className="grid gap-3">
      <Skeleton className="h-[72px] rounded-lg" />
      <Skeleton className="h-[72px] rounded-lg" />
      <Skeleton className="h-[72px] rounded-lg" />
    </div>
  );
}

function RubricListContainerContent({ orgId }: RubricListContainerProps) {
  const { data } = useSuspenseQuery(toSuspense(getListRubricsQueryOptions({ orgId })));
  const orgSlug = useOrgSlug();

  return (
    <RubricList
      rubrics={data}
      getLinkProps={(rubric) => ({
        to: '/orgs/$orgSlug/rubrics/$rubricId',
        params: { orgSlug, rubricId: rubric.id },
      })}
    />
  );
}

export function RubricListContainer({ orgId }: RubricListContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<RubricListSkeleton />}>
        <RubricListContainerContent orgId={orgId} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
